// multibox
export const multiboxEdit = (multiboxId) => `/multibox/${multiboxId}/edit`;
export const multiboxUsers = (multiboxId) => `/multibox/${multiboxId}/users`;

// single box
export const boxHistory = (boxId) => `/multibox/boxes/${boxId}/history`;
